// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"yT-z","inlineTitle":"zT-z","sponsoredAdsWrapper":"AT-z","marketplaceRecosWrapper":"BT-z"};